module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chap-ttl",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/toc#chap_1"
    }
  }, [_c('i', [_vm._v("Chapter")]), _c('br'), _c('span', {
    staticClass: "big1"
  }, [_c('i', [_vm._v("One")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ser-right"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/cycle.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("When Alicia decided to become a bicycle hooker, her mother agreed to sell a ring that had been in the family for five generations. She got $350 for it, and for $280 they bought an English mountain-bike, one with wide tires and lots of speeds, on which Alicia launched her hunt for moneyed foreigners.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was not until two months later, however, that Alicia perfected her technique. She got rid of the English bike, for which she received $120 and a heavy old Chinese bike on which she developed her “lost pedal” routine. That was when her real success began.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The hoax was conceived and executed in the inner courtyard of an old building on Amargura Street. The author was Pepone, a bicycle genius who specialized in "), _c('i', [_vm._v("“Substitutive Cyclomechanics,”")]), _vm._v(" according to the sheet of aluminum lettered in red lead that hung at the entrance to his tenement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For two bottles of "), _c('i', [_vm._v("aguardiente")]), _vm._v(" rum, Pepone fixed the locknut on the pedal with a linchpin that Alicia could easily remove. All she had to do was lean over a little, without stopping her pedaling, and with a slight tug bring about, whenever she felt like it, the spectacular loss of a pedal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The next step in her routine was to clamp on the brakes, which sent her flying into a face-down (ass-up) landing on the pavement. With a good pair of gloves and a lot of practice, Alicia had the fall down to a science and was ultimately able to get through it without a scratch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The accident would always take place about sixty feet in front of some expensive car whose foreign driver had already been entranced by the rhythmic gyrations of that—oh, so maximus!—gluteus churning on the seat she had purposely set much too high on the frame.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was simple. Whenever a car that should have passed her actually reduced speed and fell in behind, it was a sure sign that the fish was on the hook.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea569b72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 78
// module chunks = 0